export const AssignFlowHideTooltipKey = 'assign-flow-hide-tooltip';
